import { Breadcrumbs } from '../translations-types';

const translations: Breadcrumbs = {
  organizationManagement: 'Organisatie beheer',
  dashboard: 'Dashbord',
};

export default translations;
